import { FieldValues } from "react-hook-form";

import { Field, FieldLabel } from "../../../../components/FormPanel";
import { SelectForm } from "../../../../components/Input";
import { COUNTRY_OPTIONS } from "../../../../utils/countries";
import { CountryFieldProps } from "./types";

export const CountryField = <T extends FieldValues>({
  control,
  label,
  disabled,
}: CountryFieldProps<T>) => (
  <Field>
    <FieldLabel htmlFor="instrument-editor-country">{label}</FieldLabel>
    <SelectForm
      id="instrument-editor-country"
      name="country"
      control={control}
      required={false}
      isClearable
      menuPlacement="auto"
      options={COUNTRY_OPTIONS}
      disabled={disabled}
    />
  </Field>
);
